import React from 'react';
import { map } from 'lodash';
import ImageInPopup from '../../../../../common/components/image_in_popup';

const StatsTable = ({ followup, conceptById }) => {
  return (
    <div className="survey-stats-table js-tags -equal-width -vertically-centered">
      {
        map(followup.result, (result, index) => (
          <div key={ `result-${index}` } className="survey-stats-table_question">
            <div className="survey-stats-table_cell -neutral -left">
              <span className="survey-stats-table_count">{ result.cnt }</span>
              <span className="survey-stats-table_percentage">{ result.perc }%</span>
              <div className="survey-stats-table_bar survey-bar -neutral -left">
                <div className="survey-bar_value" style={ { width: `${result.perc}%` } } />
              </div>
            </div>
            <div className="survey-stats-table_cell">
              <div className="survey-stats-table_image-wrapper -image-has-title">
                {
                  !!conceptById(result.id).id &&
                  <div className="survey-stats-table_image-inner-wrapper -sm ng-isolate-scope">
                    <ImageInPopup
                      scrollMargin
                      className="-pointer survey-stats-table_image"
                      customZIndex={ 1062 }
                      src={ conceptById(result.id).src }
                    >
                      <img
                        className="-pointer"
                        src={ conceptById(result.id).src }
                        alt={ conceptById(result.id).name }
                      />
                    </ImageInPopup>
                  </div>
                }
                <div className="survey-stats-table_image-title">
                  { conceptById(result.id).name }
                </div>
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );
};

export default StatsTable;
